import React from 'react'
import PropTypes from 'prop-types'

import { News } from '../../../../../../entities/News'

import RCArticleShare from './RCArticleShare/RCArticleShare'
import { RCSectionTitle } from '../../../../RCSectionTitle/RCSectionTitle'
import { RCSingleArticleQuote } from './RCSingleArticleQuote/RCSingleArticleQuote'
import { ErrorBoundary } from '../../../../../components/ErrorBoundary/ErrorBoundary'
import { GallerySlider } from '../../../../../components/GallerySlider/GallerySlider'

import './RCMainArticleContent.css'

const RCMainArticleContent = ({ article }) => {
    const {
        title,
        htmlIntro,
        htmlContentShort,
        htmlContent,
        newsDescription,
        antrfile,
        galleryItems,
        displayDate,
        articleHeadlineImage,
        imageSource
    } = article

    return (
        <div className="rc-main-article-content">
            <div className="rc-main-article-content__main">
                <RCSectionTitle title={title} />
                <div className="rc-main-article-content__main__date">{displayDate}</div>
                <div
                    className="rc-main-article-content__main__content-short"
                    dangerouslySetInnerHTML={htmlContentShort}
                />
                {articleHeadlineImage && (
                    <div
                        className="rc-main-article-content__main__headline-image"
                        style={{ backgroundImage: `url("${articleHeadlineImage}")` }}
                    >
                        <div className="rc-main-article-content__main__headline-image__source">
                            {imageSource}
                        </div>
                    </div>
                )}
                {antrfile && <RCSingleArticleQuote antrfile={htmlIntro} />}
                <div
                    className="rc-main-article-content__main__text-content"
                    dangerouslySetInnerHTML={htmlContent}
                />
                <ErrorBoundary>
                    {galleryItems && <GallerySlider galleryItems={galleryItems} />}
                </ErrorBoundary>
                <RCArticleShare description={newsDescription} title={title} />
            </div>
            {/* <SingleArticleButtons /> */}
        </div>
    )
}

RCMainArticleContent.propTypes = {
    article: PropTypes.instanceOf(News).isRequired
}

export { RCMainArticleContent }
